import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { WpProvider } from '../../providers/wp/wp';
import { PhcApp } from '../../classes/phc-app/phc-app';
import { ViewController } from 'ionic-angular';
import { SignaturePad } from 'angular2-signaturepad/signature-pad';

/**
 * Generated class for the WelcomeMessageComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'welcome-message',
  templateUrl: 'welcome-message.html'
})
export class WelcomeMessageComponent implements AfterViewInit, OnDestroy {

  signed = false;
  drawLoopReq;

  ngAfterViewInit() {
    if (this.app.require_signin) {
      setTimeout(() => {
        this.initSignaturePanel();
      }, 1000);
    }

  }

  ngOnDestroy() {
    console.log('destroyed');
    window.cancelAnimationFrame(this.drawLoopReq);
  }

  initSignaturePanel() {
    const canvas: any = document.getElementById("sig-canvas");
    const ctx = canvas.getContext("2d");
    ctx.strokeStyle = "#222222";
    ctx.lineWidth = 2;

    let drawing = false;
    let mousePos = { x:0, y:0 };
    let lastPos = mousePos;
    canvas.addEventListener("mousedown", (e) => {
      this.signed = true;
      drawing = true;
      lastPos = getMousePos(canvas, e);
    }, false);
    canvas.addEventListener("mouseup", (e) => {
      drawing = false;
    }, false);
    canvas.addEventListener("mousemove", (e) => {
      mousePos = getMousePos(canvas, e);
    }, false);

// Get the position of the mouse relative to the canvas
    function getMousePos(canvasDom, mouseEvent) {
      const rect = canvasDom.getBoundingClientRect();
      return {
        x: mouseEvent.clientX - rect.left,
        y: mouseEvent.clientY - rect.top
      };
    }

    // Draw to the canvas
    function renderCanvas() {
      if (drawing) {
        ctx.moveTo(lastPos.x, lastPos.y);
        ctx.lineTo(mousePos.x, mousePos.y);
        ctx.stroke();
        lastPos = mousePos;
      }
    }

    const drawLoop = () => {
      this.drawLoopReq = window.requestAnimationFrame(drawLoop);
      renderCanvas();
    };

    drawLoop();

    canvas.addEventListener("touchstart", function (e) {
      mousePos = getTouchPos(canvas, e);
      var touch = e.touches[0];
      var mouseEvent = new MouseEvent("mousedown", {
        clientX: touch.clientX,
        clientY: touch.clientY
      });
      canvas.dispatchEvent(mouseEvent);
    }, false);
    canvas.addEventListener("touchend", function (e) {
      var mouseEvent = new MouseEvent("mouseup", {});
      canvas.dispatchEvent(mouseEvent);
    }, false);
    canvas.addEventListener("touchmove", function (e) {
      var touch = e.touches[0];
      var mouseEvent = new MouseEvent("mousemove", {
        clientX: touch.clientX,
        clientY: touch.clientY
      });
      canvas.dispatchEvent(mouseEvent);
    }, false);

// Get the position of a touch relative to the canvas
    function getTouchPos(canvasDom, touchEvent) {
      var rect = canvasDom.getBoundingClientRect();
      return {
        x: touchEvent.touches[0].clientX - rect.left,
        y: touchEvent.touches[0].clientY - rect.top
      };
    }

    // Prevent scrolling when touching the canvas
    document.body.addEventListener("touchstart", function (e) {
      if (e.target == canvas) {
        e.preventDefault();
      }
    }, false);
    document.body.addEventListener("touchend", function (e) {
      if (e.target == canvas) {
        e.preventDefault();
      }
    }, false);
    document.body.addEventListener("touchmove", function (e) {
      if (e.target == canvas) {
        e.preventDefault();
      }
    }, false);

  }

  dismiss() {
    this.viewCtrl.dismiss();
  }


  text: string;
  app: PhcApp;
  firstName = '';
  lastName = '';
  signature = '';
  down; X; Y;

  constructor(private wp: WpProvider, private viewCtrl: ViewController) {
    console.log('Hello WelcomeMessageComponent Component');
    this.text = 'Hello World';
    this.app = wp.app;
  }

}



// WEBPACK FOOTER //
// ./src/components/welcome-message/welcome-message.ts